import axios, { AxiosError } from "axios";
import api from "../services/api";

export const login = async () => {
  const email = localStorage.getItem("@REALIZAR:user_email");
  const password = localStorage.getItem("@REALIZAR:user_pass");

  if (
    email !== null &&
    email !== undefined &&
    password !== null &&
    password !== undefined
  ) {
    const response = await api
      .post("/login", {
        email,
        pass: password,
      })
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          //@ts-ignore
          const { data } = err.response;

          return data;
        }
      });

    localStorage.removeItem("@REALIZAR:user_email");
    localStorage.removeItem("@REALIZAR:user_password");

    if (response.error) return response;
    else return response.data;
  }
};

export const logoff = async () => {
  const response = await api
    .post("/logout")
    .catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        //@ts-ignore
        const { data } = err.response;

        return data;
      }
    });

  return response.data;
};
